"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EcommerceServiceV1Impl = void 0;
class EcommerceServiceV1Impl {
    constructor(delegate) {
        this.delegate = delegate;
    }
    get checkout() {
        if (this.delegate.checkout) {
            return Object.assign({ vehicleModelId: 'not used' }, this.delegate.checkout);
        }
        return undefined;
    }
    get confirmation() {
        return this.delegate.confirmation;
    }
    startCheckout(checkout) {
        const checkoutV2 = {
            brand: checkout.brand,
            customerType: checkout.customerType,
            ecommerceCheckoutType: checkout.ecommerceCheckoutType,
            financialProduct: checkout.financialProduct,
            vehicleIdentifier: checkout.vehicleIdentifier,
            webCalcRequest: checkout.webCalcRequest,
        };
        this.delegate.startCheckout(checkoutV2);
    }
    updateWebcalcRequest(data) {
        this.delegate.updateWebcalcRequest(data);
    }
    confirmCheckout(confirmation) {
        this.delegate.confirmCheckout(confirmation);
    }
    subscribe(listener) {
        return this.delegate.subscribe(listener);
    }
}
exports.EcommerceServiceV1Impl = EcommerceServiceV1Impl;
//# sourceMappingURL=ecommerce-service.js.map